<template>
  <div class="imgContainer">
    <img :src="`./img/${content}`" :class="type" :id="title" />
  </div>
</template>

<script>
export default {
  name: "image-block",
  data() {
    return {
      publicPath: process.env.BASE_URL
    };
  },
  computed: {
    type: function() {
      return this.content.substring(0, this.content.indexOf("_"));
    },
    title: function() {
      return this.content.substring(0, this.content.indexOf(".png"));
    }
  },
  props: {
    content: {
      type: String,
      required: true
    }
  }
};
</script>

<style <style lang="scss" scoped>
.imgContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;

  .zitat {
    height: 50%;
    width: auto;
  }

  .zwischentitel {
    height: 100%;
    width: auto;
  }

  .img {
    height: 265%;
    width: auto;
  }

  #titel {
    height: 160%;
    width: auto;
  }

  #inhalt {
    height: 120%;
    width: auto;
  }

  #allens {
    height: 100%;
    width: auto;
  }
    #img_10 {
    height: 300%;
    width: auto;
  }
      #img_11 {
    height: 300%;
    width: auto;
  }
      #img_12 {
    height: 300%;
    width: auto;
  }
      #img_13 {
    height: 300%;
    width: auto;
  }
      #img_14 {
    height: 300%;
    width: auto;
  }
    #img_15 {
    height: 300%;
    width: auto;
  }
      #img_16 {
    height: 300%;
    width: auto;
  }
}
</style>
